// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2JHw3","question":"Question_question__1q_f1","description":"Question_description__29xAt"};